import { registerUser } from "../js/api/auth";
import { getRoles } from "../js/api/get-thingy";

new Vue({
  el: "#app",
  data: {
    roles: [],
    role: "",
    role_id: null,
    name: "",
    password: "",
    email: "",
    phone: "",
    isSubmitting: false,
    // companyName: "",
  },
  mounted: async function () {
    let res = await getRoles();
    console.log(res);
    this.roles = res;
  },
  methods: {
    setType: function (type) {
      // this.role = type;
      // const role_id = this.roles.find((role) => role.name === type).id;
      // this.role_id = role_id;
      this.role_id = type;
      window.scrollTo(0, 0);
    },
    submitForm: async function (e) {
      let data = {
        name: this.name,
        password: this.password,
        role_id: this.role_id,
        email: this.email,
      };
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("password", this.password);
      formData.append("role_id", this.role_id);
      formData.append("email", this.email);

      console.log(data);
      try {
        this.isSubmitting = true;
        await registerUser(formData);
        let nextRoute = `/post-signup.html?role_id=${this.role_id}`;
        window.location.assign(nextRoute);
      } catch (err) {
        this.isSubmitting = false;
        alert("Something went wrong, please try again.");
        console.error(err);
      }
    },
  },
});
